import { useSelector } from 'react-redux';

export const useBooksData = () => useSelector(({ one_board }) => one_board.book_data);

export const useLoadingBooksData = () => useSelector(({ one_board }) => one_board.loading);
